var map = {
	"./ABC Brasil/index.svg": 4281,
	"./Ailos/index.svg": 8004,
	"./Asaas IP S.A/index.svg": 4306,
	"./BRB - Banco de Brasilia/index.svg": 7052,
	"./Banco BS2 S.A/index.svg": 1192,
	"./Banco BTG Pacutal/index.svg": 3556,
	"./Banco C6 S.A/index.svg": 5738,
	"./Banco Caixa Econômica Federal/index.svg": 8669,
	"./Banco Daycoval/index.svg": 6188,
	"./Banco Industrial do Brasil S.A/index.svg": 6342,
	"./Banco Inter S.A/index.svg": 3127,
	"./Banco Mercantil do Brasil S.A/index.svg": 4174,
	"./Banco Original S.A/index.svg": 9176,
	"./Banco Pine/index.svg": 9055,
	"./Banco Rendimento/index.svg": 6700,
	"./Banco Safra S.A/index.svg": 92,
	"./Banco Santander Brasil S.A/index.svg": 2854,
	"./Banco Sofisa/index.svg": 3416,
	"./Banco Topazio/index.svg": 3725,
	"./Banco Triângulo - Tribanco/index.svg": 1082,
	"./Banco da Amazônia S.A/index.svg": 6993,
	"./Banco do Brasil S.A/index.svg": 3631,
	"./Banco do Estado do Espirito Santo/index.svg": 5435,
	"./Banco do Estado do Para/index.svg": 1957,
	"./Banco do Estado do Sergipe/index.svg": 512,
	"./Banco do Nordeste do Brasil S.A/index.svg": 936,
	"./Bancos Escuros/banco btg pacutal/index.svg": 351,
	"./Bancos Escuros/banco rendimento/index.svg": 2125,
	"./Bancos Escuros/banco safra s.a/index.svg": 6319,
	"./Bancos Escuros/bb/index.svg": 4815,
	"./Bank of America/index.svg": 7689,
	"./Banrisul/index.svg": 3882,
	"./Bradesco S.A/index.svg": 8803,
	"./Capitual/index.svg": 8929,
	"./Conta Simples Soluções em Pagamentos/index.svg": 7504,
	"./Cora Sociedade Credito Direto S.A/index.svg": 4993,
	"./Credisis/index.svg": 166,
	"./Cresol/index.svg": 3272,
	"./Efí - Gerencianet/index.svg": 6122,
	"./Grafeno/index.svg": 7334,
	"./Itaú Unibanco S.A/index.svg": 3753,
	"./Lets Bank S.A/index.svg": 4420,
	"./Mercado Pago/index.svg": 4896,
	"./Nu Pagamentos S.A/index.svg": 5638,
	"./Omie.Cash/index.svg": 1453,
	"./PagSeguro Internet S.A/index.svg": 3038,
	"./Quality Digital Bank/index.svg": 1005,
	"./Sicoob/index.svg": 4635,
	"./Sicredi/index.svg": 3137,
	"./Stone Pagamentos S.A/index.svg": 5708,
	"./Unicred/index.svg": 2850,
	"./Uniprime/index.svg": 7017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1842;